import { createTheme, alpha, Theme } from '@mui/material/styles';

export type AppThemeMode = 'light' | 'dark';

export type AppTheme = Theme & {
    custom: {
        accentSurface: string;
    };
};

const brand = {
    primary: 'hsl(122, 39%, 50%)',
    primaryDark: 'hsl(122, 39%, 40%)',
    header: '#5e5373',
    error: '#dc3545',
};

export const getAppTheme = (mode: AppThemeMode): AppTheme => {
    const isDark = mode === 'dark';

    const theme = createTheme({
        palette: {
            mode,
            primary: {
                main: brand.primary,
                dark: brand.primaryDark,
                contrastText: '#fff',
            },
            secondary: {
                main: brand.header,
            },
            error: {
                main: brand.error,
            },
            background: {
                default: isDark ? '#121212' : '#f7f7f8',
                paper: isDark ? '#1e1e1e' : '#fff',
            },
            text: {
                primary: isDark ? '#f1f1f1' : '#212121',
                secondary: isDark ? '#b3aebd' : 'hsl(260, 16%, 30%)',
            },
            divider: isDark ? 'rgba(255, 255, 255, .12)' : 'rgba(0, 0, 0, .12)',
        },
        typography: {
            fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,Liberation Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji',
        },
    });

    return Object.assign(theme, {
        custom: {
            accentSurface: isDark ? alpha('#8a7ca8', 0.16) : '#ede9f4',
        },
    });
};
